import { Injectable } from '@angular/core';
import { Plugins } from '@capacitor/core';

const { FirebaseCrashlytics } = Plugins;

@Injectable({
    providedIn: 'root'
})
export class CrashlyticsService {
    constructor() {}

    public recordException(message: string, code?: number) {
        FirebaseCrashlytics.recordException({
            message,
            code
        });
    }
}
